/**
 * ULD (Unit Load Device) API Service
 * 提供与ULD相关的所有API接口封装
 */

import axios from "./axios";

// 基础路径
const BASE_PATH = "/v1/uld";

/**
 * ULD基础CRUD操作
 */

// 创建ULD（支持单个和批量）
export const createUld = (data) => {
    return axios.post(`${BASE_PATH}/master`, data);
};

// 获取ULD详情
export const getUldDetail = (uldId) => {
    return axios.get(`${BASE_PATH}/master/${uldId}`);
};

// 根据ULD识别码获取详情
export const getUldByIdentifier = (identifier) => {
    return axios.get(`${BASE_PATH}/master/identifier/${identifier}`);
};

// 更新ULD基础信息
export const updateUldMaster = (uldId, data) => {
    return axios.put(`${BASE_PATH}/master/${uldId}`, data);
};

// 删除ULD
export const deleteUldMaster = (uldId) => {
    return axios.delete(`${BASE_PATH}/master/${uldId}`);
};

/**
 * ULD单个操作
 */

// 更新单个ULD位置
export const updateSingleUldLocation = (uldId, data) => {
    return axios.put(`${BASE_PATH}/${uldId}/location`, data);
};

// 更新单个ULD状态
export const updateSingleUldStatus = (uldId, data) => {
    return axios.put(`${BASE_PATH}/${uldId}/status`, data);
};

// 管理单个ULD标签
export const manageSingleUldTags = (uldId, data) => {
    return axios.put(`${BASE_PATH}/${uldId}/tags`, data);
};

// 更新单个ULD照片
export const updateUldPhotos = (uldId, data) => {
    return axios.put(`${BASE_PATH}/${uldId}/photos`, data);
};

// 更新单个ULD核心状态（V3新功能）
export const updateSingleUldCoreStatus = (uldId, data) => {
    return axios.put(`${BASE_PATH}/${uldId}/core-status`, data);
};

/**
 * ULD批量操作
 */

// 批量更新ULD位置
export const batchUpdateLocation = (data) => {
    return axios.post(`${BASE_PATH}/batch/location-update`, data);
};

// 批量更新ULD状态
export const batchUpdateStatus = (data) => {
    return axios.post(`${BASE_PATH}/batch/status-update`, data);
};

// 批量管理ULD标签
export const batchManageTags = (data) => {
    return axios.post(`${BASE_PATH}/batch/tag-manage`, data);
};

// 批量更新ULD持有者
export const batchUpdateHolder = (data) => {
    return axios.post(`${BASE_PATH}/batch/holder-update`, data);
};

// 批量更新ULD备注
export const batchUpdateRemarks = (data) => {
    return axios.post(`${BASE_PATH}/batch/remarks-update`, data);
};

// 批量校正ULD数据
export const batchCorrectData = (data) => {
    return axios.post(`${BASE_PATH}/batch/correction`, data);
};

// 批量更新ULD核心状态（V3新功能）
export const batchUpdateCoreStatus = (data) => {
    return axios.post(`${BASE_PATH}/batch/core-status-update`, data);
};

// 批量删除ULD
export const batchDeleteUlds = (data) => {
    return axios.post(`${BASE_PATH}/batch/delete`, data);
};

/**
 * ULD查询功能
 */

// 查询ULD列表
export const listUlds = (params) => {
    return axios.get(`${BASE_PATH}/list`, { params });
};

// 获取ULD历史记录列表
export const listUldHistory = (params) => {
    return axios.get(`${BASE_PATH}/history`, { params });
};

// 获取特定ULD的流转历史
export const getUldHistory = (uldId, params) => {
    return axios.get(`${BASE_PATH}/${uldId}/history`, { params });
};

/**
 * ULD统计功能
 */

// 获取ULD统计信息
export const getUldStatistics = (params) => {
    return axios.get(`${BASE_PATH}/statistics`, { params });
};

// 获取ULD利用率统计
export const getUldUtilization = (params) => {
    return axios.get(`${BASE_PATH}/statistics/utilization`, { params });
};

// 获取ULD流转统计
export const getUldMovementStats = (params) => {
    return axios.get(`${BASE_PATH}/statistics/movement`, { params });
};

// 获取长时间无动态ULD列表（统计专用）
export const getInactiveUlds = (params) => {
    return axios.get(`${BASE_PATH}/statistics/inactive`, { params });
};

/**
 * ULD标签定义管理
 */

// 获取所有标签定义
export const listTagDefinitions = () => {
    return axios.get(`${BASE_PATH}/tags`);
};

// 创建标签定义
export const createTagDefinition = (data) => {
    return axios.post(`${BASE_PATH}/tags`, data);
};

// 更新标签定义
export const updateTagDefinition = (tagId, data) => {
    return axios.put(`${BASE_PATH}/tags/${tagId}`, data);
};

// 删除标签定义
export const deleteTagDefinition = (tagId) => {
    return axios.delete(`${BASE_PATH}/tags/${tagId}`);
};

/**
 * ULD筛选选项API
 */

// 获取所有者选项列表
export const getOwnerOptions = () => {
    return axios.get(`${BASE_PATH}/filter-options/owners`);
};

// 获取持有者选项列表
export const getHolderOptions = () => {
    return axios.get(`${BASE_PATH}/filter-options/holders`);
};

// 获取地面处理代理选项列表
export const getGhaOptions = () => {
    return axios.get(`${BASE_PATH}/filter-options/ghas`);
};

// 获取标签名称选项列表
export const getTagNameOptions = () => {
    return axios.get(`${BASE_PATH}/filter-options/tag-names`);
};

/**
 * 获取航班维度ULD统计
 * @param {Object} params - 查询参数
 * @param {string[]} params.airport_iatas - 机场IATA代码数组
 * @param {string[]} params.core_statuses - 核心状态筛选
 * @param {string[]} params.availabilities - 可用性筛选
 * @param {string} params.start_date - 开始日期
 * @param {string} params.end_date - 结束日期
 * @returns {Promise} 包含航班维度ULD统计的响应
 */
export const getFlightUldStatistics = async (params = {}) => {
    return axios.get(`${BASE_PATH}/flight-statistics`, { params });
};

/**
 * ULD导出功能
 */

// 导出筛选的ULD数据
export const exportFilteredUlds = (data) => {
    return axios.post("/v1/export/uld/filtered", data);
};

// 导出ULD历史记录
export const exportUldHistory = (data) => {
    return axios.post("/v1/export/uld/history", data);
};

// 注意：ULD统计导出功能已移至 exportApi.js 中统一管理

// 批量导出ULD
export const batchExportUlds = (data) => {
    return axios.post("/v1/export/uld/batch", data);
};

// 导出单个ULD数据
export const exportSingleUld = (uldId, options = {}) => {
    return axios.post(`/v1/export/uld/${uldId}`, options);
};

// 导出所有API函数
export default {
    // ULD基础CRUD操作
    createUld,
    getUldDetail,
    getUldByIdentifier,
    updateUldMaster,
    deleteUldMaster,

    // ULD单个操作
    updateSingleUldLocation,
    updateSingleUldStatus,
    manageSingleUldTags,
    updateUldPhotos,
    updateSingleUldCoreStatus,

    // ULD批量操作
    batchUpdateLocation,
    batchUpdateStatus,
    batchManageTags,
    batchUpdateHolder,
    batchUpdateRemarks,
    batchCorrectData,
    batchUpdateCoreStatus,
    batchDeleteUlds,

    // ULD查询功能
    listUlds,
    listUldHistory,
    getUldHistory,

    // ULD统计功能
    getUldStatistics,
    getUldUtilization,
    getUldMovementStats,
    getInactiveUlds,

    // ULD标签定义管理
    listTagDefinitions,
    createTagDefinition,
    updateTagDefinition,
    deleteTagDefinition,

    // ULD筛选选项API
    getOwnerOptions,
    getHolderOptions,
    getGhaOptions,
    getTagNameOptions,

    // 获取航班维度ULD统计
    getFlightUldStatistics,

    // ULD导出功能
    exportFilteredUlds,
    exportUldHistory,
    // 注意：ULD统计导出功能已移至 exportApi.js 中统一管理
    batchExportUlds,
    exportSingleUld,
};
